import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ModalBaseSm = ({ isOpen, onClose, title, childComponent, children, className = '', size = 'sm' }) => {
    const backdropStyle = 'static';
    const modalStyle = {};
    return (
        <Modal

            isOpen={isOpen}
            backdrop={backdropStyle}
            keyboard={false}
            size={size}
            className={className}
            zIndex={9999}
            fade={false}
            style={modalStyle}
            centered
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                {childComponent ?? children}
            </ModalBody>
        </Modal >
    )
}

export default ModalBaseSm
